<template>
  <div>
    <PreloaderComponent v-if="loading"/>
    <LoginComponent
      v-else-if="need_esia_auth"
      :errors="esiaErrors"
    />
    <AnketaComponent
      v-else-if="need_anketa"
      :data="baseInfo"
      @successfulAnketaCheck="need_anketa = false"
    />
    <div v-else>
      <h2 style="margin-top: 20px; margin-left: 20px;" v-if="error_desc">{{ error_desc }}</h2>
      <div v-if="!error_desc" class="finalPage">
        <div class="finalPage__header">
          <h1>{{ contractName }}</h1>
          <div v-if="baseInfo?.signed !== true">
            <span>Уважаемый клиент!</span>
            <span>
              Договор заключается в электронном виде, подписание документов осуществляется ПЭП (простой электронной подписью) после ознакомления и подтверждения информации, указанной ниже, посредством ввода кода, который будет направлен Вам в смс-сообщении на мобильный телефон.
            </span>
            <span style="color: rgb(41 179 68); font-weight: 500">
              Есть возможность указать электронную почту. На данный адрес будет направлен пакет документов по договору страхования.
            </span>
          </div>
          <input v-if="baseInfo?.signed !== true" v-model="email" type="email" style="margin-top: 10px; "
                 placeholder="Электронная почта">
        </div>

        <div v-if="baseInfo?.signed !== true" class="finalPage__checkboxBlock">
          <QualifiedInvestor
            v-if="need_qualified_investor"
            :link="qualifiedInvestorLinkComputed"
            @update-answers="handleAnswersUpdate"
          />
          <div class="finalPage__checkboxItem">
            <input v-model="checkbox_no_usa_citizenship" type="checkbox" value=""/>
            <span><b>Страхователь подтверждает, что не&nbsp;имеет гражданства США, разрешения на&nbsp;постоянное пребывание в&nbsp;США и&nbsp;не&nbsp;является налоговым резидентом США.</b></span>
          </div>
          <div class="finalPage__checkboxItem">
            <input v-model="checkbox_no_connections" type="checkbox" value=""/>
            <div>
              <b>Страхователь подтверждает, что не является:</b>
              <span class="ml-12" style="margin-top: 5px;">&mdash; иностранным публичным должностным лицом, должностным лицом публичных международных организаций;</span>
              <span class="ml-12" style="margin-top: 10px;">&mdash; лицом, замещающим (занимающим) государственные должности&nbsp;РФ, должности членов Совета директоров ЦБ&nbsp;РФ, должности федеральной государственной службы, назначение на&nbsp;которые и&nbsp;освобождение от&nbsp;которых осуществляется Президентом РФ&nbsp;или Правительством&nbsp;РФ, должности в&nbsp;ЦБ&nbsp;РФ, государственных корпорациях и&nbsp;иных организациях, созданных&nbsp;РФ на&nbsp;основании федеральных законов, включенные в&nbsp;перечни должностей, определяемые Президентом РФ;</span>
              <span class="ml-12" style="margin-top: 10px;">&mdash; супругой(-ом), близким родственником лиц, указанных в&nbsp;настоящем подпункте.</span>
              <span class="ml-12" style="margin-top: 10px;">Оплачивать договор страхования необходимо банковской картой, оформленной на&nbsp;имя Страхователя. При оплате договора третьим лицом может быть удержан налог с&nbsp;внесенной суммы.</span>
            </div>
          </div>
          <div class="finalPage__checkboxItem">
            <input v-model="checkbox_tax_info" type="checkbox" value=""/>
            <div>
              <b>Страхователь подтверждает, что ему доведена следующая информация:</b>
              <span class="ml-12" style="margin-top: 5px;">&mdash; Я уведомлен, что в соответствии со ст. 213 НК РФ НДФЛ взимается с суммы превышения страховой выплаты над суммой, оплаченной в качестве страховой премии по договору лично Страхователем;</span>
              <span class="ml-12" style="margin-top: 10px;">&mdash; Я уведомлен, что в соответствии со ст. 213 НК РФ страховая выплата по дожитию не облагается НДФЛ в полном объеме только в случаях, если получателем страховой выплаты по договору страхования является Застрахованный и оплата договора страхования производилась лично получателем страховой выплаты, являющимся Страхователем по договору;</span>
            </div>
          </div>
          <div class="finalPage__checkboxItem">
            <input v-model="checkbox_data_policy" type="checkbox" value=""/>
            <span>Согласен с
              <a target="_blank" href="https://makclife.ru/o-kompanii/obrabotka-personalnykh-dannykh.php">Политикой обработки данных</a>
            </span>
          </div>
          <div class="finalPage__checkboxItem">
            <input v-model="checkbox_user_agreement" type="checkbox" value=""/>
            <span>
              Ознакомился и согласился с
              <a target="_blank"
                 href="https://makclife.ru/upload/medialibrary/ccd/6pjeojh3n88olxsr260qycrzw40gum8m/%D0%A1%D0%BE%D0%B3%D0%BB%D0%B0%D1%81%D0%B8%D0%B5%20%D0%9F%D0%AD%D0%9F%20%D0%9C%D0%90%D0%9A%D0%A1-%D0%96%D0%B8%D0%B7%D0%BD%D1%8C.pdf">Пользовательским соглашением
            </a>
            </span>
          </div>
          <div class="finalPage__checkboxItem" v-if="pdsKidLinkComputed">
            <input v-model="pds.kid" type="checkbox" value=""/>
            <span>Согласен с
              <a target="_blank" :href="pdsKidLinkComputed">Ключевым информационным документом</a>
            </span>
          </div>
          <div class="finalPage__checkboxItem" v-if="pdsPaymentMethodsLinkComputed">
            <input v-model="pds.payment_methods" type="checkbox" value=""/>
            <span>Согласен со
              <a target="_blank" :href="pdsPaymentMethodsLinkComputed">способом оплаты ПДС</a>
            </span>
          </div>
          <div class="finalPage__checkboxItem" v-if="pdsAgreementLinkComputed">
            <input v-model="pds.agreement" type="checkbox" value=""/>
            <span>Согласен с
              <a target="_blank" :href="pdsAgreementLinkComputed">Анкетой согласия ПДС</a>
            </span>
          </div>
          <div class="finalPage__checkboxItem" v-if="pdsContractLinkComputed">
            <input v-model="pds.contract" type="checkbox" value=""/>
            <span>Согласен с
              <a target="_blank" :href="pdsContractLinkComputed">Договором ПДС</a>
            </span>
          </div>
          <div class="finalPage__checkboxItem" v-if="kidLinkComputed">
            <input :disabled="!checkbox_user_agreement" v-model="checkbox_kid" type="checkbox" value=""/>
            <span v-if="!checkbox_user_agreement">Ознакомился с Ключевым информационным документом</span>
            <span v-else>Ознакомился с
              <a target="_blank" :href="kidLinkComputed">Ключевым информационным документом</a>
            </span>
          </div>
          <div class="finalPage__checkboxItem" v-if="contractLinkComputed || rulesLinkComputed">
            <input :disabled="!checkbox_user_agreement" v-model="checkbox_rules_and_contract" type="checkbox" value=""/>
            <span
              v-if="!checkbox_user_agreement">Ознакомился и согласился с Условиями полиса и Правилами страхования</span>
            <span v-else>
              Ознакомился и согласился с
              <a v-if="contractLinkComputed" target="_blank" :href="contractLinkComputed">Условиями полиса</a>
              <span v-if="contractLinkComputed && rulesLinkComputed"> и </span>
              <a v-if="rulesLinkComputed" target="_blank" :href="rulesLinkComputed">Правилами страхования</a>
            </span>
          </div>
        </div>
        <div v-if="baseInfo?.signed !== true" style="margin-top: 15px;">
          Для подписания договора страхования простой электронной подписью необходимо ввести код из СМС, который будет
          Вам направлен на указанный номер телефона
        </div>
        <SmsComponent
          :active="smsActivationComputed"
          :checkboxObject="objectForSmsComputed"
          :qualInvestorObject="qualInvestorResults"
          :email="email"
          :signed="baseInfo?.signed"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PreloaderComponent from "@/create/components/PreloaderComponent";
import axios from "axios";
import {baseURL} from "@/create/composables/const";
import SmsComponent from "@/create/components/finalPage/SmsComponent";
import AnketaComponent from "@/create/components/finalPage/AnketaComponent";
import LoginComponent from "@/create/components/finalPage/LoginComponent";
import QualifiedInvestor from "@/create/components/finalPage/QualifiedInvestor";

export default {
  name: "FinalPage",
  components: {QualifiedInvestor, LoginComponent, AnketaComponent, PreloaderComponent, SmsComponent},
  data: () => {
    return {
      loading: true,
      error_desc: null,
      email: null,
      checkbox_no_usa_citizenship: false,
      checkbox_no_connections: false,
      checkbox_tax_info: false,
      checkbox_data_policy: false,
      checkbox_user_agreement: false,
      checkbox_kid: false,
      checkbox_rules_and_contract: false,
      baseInfo: null,
      need_anketa: false,
      need_qualified_investor: false,
      need_esia_auth: false,
      qualInvestorResults: {
        checkbox_1: null,
        checkbox_2: null,
        checkbox_3: null,
        checkbox_4: null
      },
      pds: {
        kid: false,
        payment_methods: false,
        agreement: false,
        contract: false,
      },
      esiaErrors: [],
    }
  },
  computed: {
    contractName() {
      return this.baseInfo?.policy ?
        `Договор ${this.baseInfo.policy.serial} ${this.baseInfo.policy.number} от ${this.baseInfo.policy.date}` : ``;
    },
    kidLinkComputed() {
      return this.baseInfo?.links?.find(el => el.id === 'kid') ? `${this.baseInfo.links.find(el => el.id === 'kid')?.link}` : null
    },
    rulesLinkComputed() {
      return this.baseInfo?.links?.find(el => el.id === 'ins_rules') ? `${this.baseInfo.links.find(el => el.id === 'ins_rules')?.link}` : null
    },
    contractLinkComputed() {
      return this.baseInfo?.links?.find(el => el.id === 'contract') ? `${this.baseInfo.links.find(el => el.id === 'contract')?.link}` : null
    },
    qualifiedInvestorLinkComputed() {
      return this.baseInfo?.links?.find(el => el.id === 'qualified_investor') ? `${this.baseInfo.links.find(el => el.id === 'qualified_investor')?.link}` : null
    },
    pdsKidLinkComputed() {
      return this.baseInfo?.links?.find(el => el.id === 'pds' && el.label === 'Ключевой информационный документ')
        ? `${this.baseInfo.links.find(el => el.id === 'pds' && el.label === 'Ключевой информационный документ').link}`
        : null
    },
    pdsPaymentMethodsLinkComputed() {
      return this.baseInfo?.links?.find(el => el.id === 'pds' && el.label === 'Способы оплаты ПДС')
        ? `${this.baseInfo.links.find(el => el.id === 'pds' && el.label === 'Способы оплаты ПДС').link}`
        : null
    },
    pdsAgreementLinkComputed() {
      return this.baseInfo?.links?.find(el => el.id === 'pds' && el.label === 'Анкета согласия ПДС')
        ? `${this.baseInfo.links.find(el => el.id === 'pds' && el.label === 'Анкета согласия ПДС').link}`
        : null
    },
    pdsContractLinkComputed() {
      return this.baseInfo?.links?.find(el => el.id === 'pds' && el.label === 'Договор ПДС')
        ? `${this.baseInfo.links.find(el => el.id === 'pds' && el.label === 'Договор ПДС').link}`
        : null
    },
    smsActivationComputed() {
      return (this.qualInvestorResultsCheck || !this.need_qualified_investor)
        && this.checkbox_no_usa_citizenship && this.checkbox_no_connections && this.checkbox_tax_info
        && this.checkbox_data_policy && this.checkbox_user_agreement && this.checkbox_rules_and_contract
        && (this.checkbox_kid || this.kidLinkComputed === null)
        && (this.pds.kid || !this.pdsKidLinkComputed)
        && (this.pds.payment_methods || !this.pdsPaymentMethodsLinkComputed)
        && (this.pds.agreement || !this.pdsAgreementLinkComputed)
        && (this.pds.contract || !this.pdsContractLinkComputed)
    },
    qualInvestorResultsCheck() { // проверка что все вопросы отвечены
      return Object.values(this.qualInvestorResults).every(
        value => value !== null
      )
    },
    objectForSmsComputed() {
      return {
        no_usa_citizenship: this.checkbox_no_usa_citizenship,
        no_connections: this.checkbox_no_connections,
        tax_info: this.checkbox_tax_info,
        data_policy: this.checkbox_data_policy,
        user_agreement: this.checkbox_user_agreement,
        kid: this.checkbox_kid,
        rules_and_contract: this.checkbox_rules_and_contract,
        pds_kid: this.pds.kid,
        pds_payment_methods: this.pds.payment_methods,
        pds_agreement: this.pds.agreement,
        pds_contract: this.pds.contract,
      }
    }
  },
  methods: {
    async getData() {
      try {
        const response = await axios.post(baseURL, {
          ver: 0,
          object: "contract",
          action: "landing_signer_base_info",
          slug: this.$route.params.slugID,
          login: "ybrir",
        });
        if (response.data.landing_signer_who_identify) {
          this.baseInfo = response.data;
          this.email = response.data.insurer?.email;
          if (response.data.need_anketa === 'Y') {
            this.need_anketa = true;
          }
          if (response.data.need_qualified_investor === true) {
            this.need_qualified_investor = true;
          }
          /*else if (response.data.links?.length > 0) {
            await this.getDocs();
          }*/
        } else if (response.data.state === "error") {
          this.error_desc = response.data.error_desc
        } else {
          this.need_esia_auth = true;
        }

        this.loading = false;

      } catch (e) {
        console.log("Frontend getData Error - " + e);
      }
    },
    // async getDocs() {
    //   try {
    //     await Promise.all(this.baseInfo.links.map(el =>
    //             axios.post(baseURL, {
    //               ver: 0,
    //               object: "contract",
    //               action: "landing_signer_link",
    //               slug: this.$route.params.slugID,
    //               login: "ybrir",
    //               link_id: el.id,
    //             })
    //                 .then(response => {
    //                   // console.log(`${el.id}:`, response.data.link);
    //                   this.baseInfo.links.find(el2 => el2.id === el.id).link = response.data.link;
    //                 })
    //                 .catch(e => {
    //                   console.log("Error1 - " + e);
    //                 })
    //         )
    //     );
    //   } catch (e) {
    //     console.log("Error2 - " + e);
    //   }
    // },
    async esiaAuth2() {
      this.esiaErrors = [];
      try {
        const response = await axios.post(baseURL, {
          ver: 0,
          object: "contract",
          login: "ybrir",
          action: "landing_signer_esia_check",
          slug: this.$route.params.slugID,
          code: this.$route.query.code
        });
        if (response.data.state === 'success') {
        } else if (response.data.state === 'error') {
          this.need_esia_auth = true;
          this.esiaErrors.push('Данные в договоре не соответствуют данным с Госуслуг');
          this.loading = false;
        }
        this.removeQueryParam();
      } catch (e) {
        console.log("Frontend esiaAuth2 Error - " + e);
      }
    },
    removeQueryParam() {
      const query = {...this.$route.query};
      delete query.code;
      delete query.state;
      delete query.q;

      this.$router.replace({path: this.$route.path, query});
    },
    async asyncCreatedHandle() {
      if (this.$route.query.code && this.$route.query.state) {
        await this.esiaAuth2();
      }
      if (this.esiaErrors.length === 0) {
        await this.getData();
      }
      document.title = "МАКС-Жизнь Подписание договора";
    },
    handleAnswersUpdate(answers) {
      this.qualInvestorResults = answers
    }
  },
  created() {
    this.asyncCreatedHandle();
  },
}
</script>

<style scoped>

</style>